module.exports = __webpack_public_path__ + "assets/img/zby_icon.28e9c726.png";